let headerHeight = $('.site-header').height();

/*
if ($(".site-header").hasClass("is-relative-fixed")) {
    $('.site-main').css('padding-top',headerHeight);
   
    if ($(window).width() >= 1450) {
        $('.leader-no-img .hero-content-wrap').css('padding-top', '90px');
    }
}
*/

if ($(window).width() < 960) {
    $(window).on("scroll", function() {
        if($(window).scrollTop() > 50) {
            console.log('activated');
            $(".site-header").addClass("is-fixed");
            $("#navbarToggle").addClass("toggle-fixed");
        } else {
            //remove the background property so it comes transparent again (defined in your css)
            $(".site-header").removeClass("is-fixed");
        }
    });
}
else {
    // if($('.site-header').hasClass('bio-detail')) {
    //     $(".site-header").addClass("bg-white");
    // }
    $(window).on("scroll", function() {
        if($(window).scrollTop() > 50) {
            $(".site-header").addClass("is-fixed");
        } else {
            //remove the background property so it comes transparent again (defined in your css)
            $(".site-header").removeClass("is-fixed");
        }
    });
}